import { Result } from "../../../common-models/Result";
import { HttpServiceBase } from "../../../common-services/Http/HttpServiceBase";
import { AddInternalCommunicationInput } from "./AddInternalCommunicationInput";
import { AddInternalCommunicationOutput } from "./AddInternalCommunicationOutput";

export class AddInternalCommunicationService extends HttpServiceBase {

  handle = (input: AddInternalCommunicationInput): Promise<Result<AddInternalCommunicationOutput> | null> => {
    const promise = this.http.post<Result<AddInternalCommunicationOutput>, AddInternalCommunicationInput>(`${this.baseUrlSislogApi}/v2/internal-communication-log`, input);
    return promise;
  }
}